import { render, staticRenderFns } from "./home_video.vue?vue&type=template&id=8ebc5ca8&scoped=true"
import script from "./home_video.vue?vue&type=script&lang=js"
export * from "./home_video.vue?vue&type=script&lang=js"
import style0 from "./home_video.vue?vue&type=style&index=0&id=8ebc5ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebc5ca8",
  null
  
)

export default component.exports